---
nb:
  personal_tokens:
    connect:
      copy_prompt: Kopier tilkoblingsinstruks
      prompt: 'Koble til Kaia Portal MCP-serveren. Transport: http. URL: {url}. Header: Authorization: Bearer {token}. List deretter kraftverkene du kan se.'
      step_copy: Kopier tokenet over; det vises ikke igjen.
      step_tell: Gi KI-assistenten din MCP-adressen {url} og tokenet, og be den koble til. Eller lim inn den ferdige instruksen under.
      step_verify: Be den liste kraftverkene den kan se. Får du en liste, er du tilkoblet.
      title: Koble til KI-assistenten din
    copy: Kopier token
    create: Opprett token
    created_title: Token opprettet
    created_warning: Kopier det nå. Dette tokenet vises ikke igjen. Del det bare med KI-assistenten du kobler til; er du i tvil, trekk det tilbake her og opprett et nytt.
    days: "{count} dager"
    done: Ferdig
    empty: Ingen tokens enda.
    errors:
      lifetime: Levetiden må være %{allowed} dager
      minting_paused: Oppretting av personlige MCP-tokens er satt på pause
    expires: Utløper {date}
    hint: For MCP-klienter som handler som deg. Samme kraftverkstilgang som denne kontoen.
    last_used: Sist brukt {date}
    lifetime: Utløper om
    name: Navn på token
    name_hint: Gi det navn etter enheten eller klienten det ligger på.
    never_used: Aldri brukt
    paused: Oppretting av tokens er satt på pause mens vi fullfører etterlevelsesgjennomgangen av MCP-serveren. Eksisterende tokens er trukket tilbake. Vi jobber med å få det tilbake.
    revoke: Trekk tilbake
    revoke_named: Trekk tilbake {name}
    revoke_text: "{name} slutter å virke umiddelbart. Dette kan ikke angres."
    revoke_title: Trekke tilbake token?
    status:
      active: Aktiv
      expired: Utløpt
      expires_soon: Utløper snart
      revoked: Trukket tilbake
    title: Personlige tilgangstokens
    toast:
      copied: Token kopiert til utklippstavlen
      copy_failed: Kunne ikke kopiere. Marker tokenet og kopier det manuelt.
      create_failed: Kunne ikke opprette token
      created: Token opprettet
      load_failed: Kunne ikke laste tokens
      prompt_copied: Tilkoblingsinstruks kopiert til utklippstavlen
      revoke_failed: Kunne ikke trekke tilbake token
      revoked: Token trukket tilbake
